import { useIsMobile } from 'hooks/common';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import styled from 'styled-components';
import { SALE_LIST_PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';

const ModalTitle = styled.h6`
  margin: 0;
  padding: 24px 20px 8px;

  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #1b1c1e;
`;

const ModalSubtitle = styled.p`
  padding: 0px 20px 16px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: #70737c;
`;

const ModalButtonBox = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 20px;

  button[data-type='text'] {
    font-weight: 500;
    font-size: 16px;
    line-height: 48px;

    background-color: transparent;

    color: #70737c;
  }

  button[data-type='confirm'] {
    height: 48px;
    padding: 0 24px;
    border-radius: 12px;

    background-color: #1b1c1e;

    font-weight: 600;
    font-size: 16px;
    line-height: 48px;

    color: #ffffff;
  }
`;

interface CanceledScheduleModalProps {
  handleModal: () => void;
  scheduleIds: string;
}

const CanceledScheduleModal = ({
  handleModal,
  scheduleIds,
}: CanceledScheduleModalProps) => {
  const navigate = useNavigate();

  const isMobile = useIsMobile();

  /* 판매내역에서 보기 */
  const goToSalesPage = () => {
    if (scheduleIds) {
      localStorage.setItem('scheduleIds', scheduleIds);

      return navigate(SALE_LIST_PATH);
    }
  };

  return (
    <ModalContainer
      isMobile={false}
      isAbled={true}
      onClick={() => {}}
      onClose={() => {}}
      isBottomSheet
      style={{ gap: 0, maxWidth: '351px' }}
    >
      <ModalTitle>일정이 취소되었습니다.</ModalTitle>

      <ModalSubtitle>
        판매 내역에서 취소된 예약자의 리스트를 확인할까요?
      </ModalSubtitle>

      <ModalButtonBox>
        <button data-type="text" onClick={handleModal}>
          아니요
        </button>
        <button data-type="confirm" onClick={goToSalesPage}>
          네, 확인할게요
        </button>
      </ModalButtonBox>
    </ModalContainer>
  );
};

export default CanceledScheduleModal;
